import React, { useEffect, useState } from "react";

import LoggedOutPage from "../components/LoggedOutPage";
import { useSearchParams } from "react-router-dom";
import Loading from "../components/Loading";
import { FormattedMessage } from "react-intl";
import { Alert, AlertProps, Stack } from "@mui/material";
import CRUDForm from "./CRUDForm";

const Registration: React.FC<{}> = () => {
    // a single alert when we are done (with success or permanent failure)
    const [alert, setAlert] = useState<{ severity: AlertProps["severity"]; label: string } | null>(null);
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [tokenValid, setTokenValid] = useState(false);

    useEffect(() => {
        setTokenValid(false);
        async function checkToken() {
            try {
                const response = await fetch(`/public/check_token/${token}`);
                if (response.ok) {
                    setTokenValid(true);
                } else {
                    setAlert({ severity: "error", label: "error_page.unauthorized_to_access_page" });
                }
            } catch (error) {
                setAlert({ severity: "error", label: "login.unexpected_error" });
            }
        }

        checkToken();
    }, [token]);

    if (alert) {
        return (
            <LoggedOutPage title={<FormattedMessage id="register" />}>
                <Stack spacing={2} alignItems="center">
                    <Alert severity={alert.severity}>
                        <FormattedMessage id={alert.label} />
                    </Alert>
                    {alert.severity === "success" && (
                        <a href="/public/login">
                            <FormattedMessage id="go_to_login" />
                        </a>
                    )}
                </Stack>
            </LoggedOutPage>
        );
    }

    // display loading while checking token
    if (!tokenValid) {
        return (
            <LoggedOutPage title={<FormattedMessage id="register" />}>
                <Loading />
            </LoggedOutPage>
        );
    }

    return (
        <LoggedOutPage title={<FormattedMessage id="register" />}>
            <CRUDForm
                resourceName="user"
                action="create"
                formFields={[
                    "password",
                    "retype_password",
                    "given_name",
                    "family_name",
                    "gender",
                    "birthdate",
                    "locale",
                ]}
                onSuccess={() => {
                    setAlert({ severity: "success", label: "registration_successful" });
                }}
                extraRequestData={{
                    token,
                }}
                overrideSubmitURI="/public/register"
            />
        </LoggedOutPage>
    );
};

export default Registration;
